/**
 * Returns attachments that are in the current level's language.
 *
 * @param {array} attachments
 * @param {string} language
 * @returns {array} attachments that are in the current language
 */
const filterAttachmentsByLanguage = (attachments, language) => {
  if (!attachments) return [];

  return attachments.filter((attachment) =>
    attachment?.data?.levels?.find((level) => level.language === language),
  );
};

export default filterAttachmentsByLanguage;
